import reduceReducers from 'reduce-reducers'
import _ from 'lodash'
import { combineReducers } from 'redux'
import {
  COPY_FORM_ELEMENTS,
} from './constants'
import {
  updateObject,
  createReducer,
} from 'helpers/ReducerUtil'

const getValuesFromEntity = (entityId, entityType, entities) => {
  const { type, ...rest } = entities[entityType][entityId]
  return { ...rest }
}

// Replace Reference with Values
const replaceValuesProperty = (elements, entities) => replaceRefWithVal(elements, entities, 'values')

// Replace reference with their entity equivalent values
// Makes sure that the property exists and updates references with values
const replaceRefWithVal = (elements, entities, property) => {
  Object.keys(elements)
    .filter(key => elements[key][property])
    .forEach(key => {
      let element = elements[key]
      element[property] = element.values.map(
        ({ id, type }) => getValuesFromEntity(id, type, entities)
      )
    }
  )
  return elements
}

// Takes all form elements from entity tree
// and saves within projectOverviews formElement state
const copyFormElements = (elements, action, entities) => {
  const entityElements = replaceValuesProperty(
    _.cloneDeep(entities.elements),
    entities
  )

  return updateObject(elements, entityElements)
}

// slices for each attribute
const productIdReducer = createReducer(311, {})
const productHierarchyIdReducer = createReducer(888, {})

const productReducer = combineReducers({
  productId: productIdReducer,
  productHierarchyId: productHierarchyIdReducer
})

const formElementReducer = createReducer({}, {})

export const productPgmOverviewReducer = combineReducers({
  elements: formElementReducer,
  product: productReducer
})

// Special reducers to be imported within entity reducer for handling seperate
// changes as it requires shared entity values
const pgmElementSliceReducer = createReducer({}, {
  [COPY_FORM_ELEMENTS]: copyFormElements
})

export const pgmElementCrossReducer = createReducer({}, {
  [COPY_FORM_ELEMENTS]: (state, action) => {
    const {
      entities,
      productPgm,
      productPgm: { elements }
    } = state

    return {
      ...state,
      productPgm: {
        ...productPgm,
        elements: pgmElementSliceReducer(elements, action, entities)
      }
    }
  }
})
